// extracted by mini-css-extract-plugin
var _1 = "uIiA3";
var _2 = "O5Qp5";
var _3 = "xu8WQ";
export { _1 as "asideIcon", _2 as "asideLogo", _3 as "firstColumn" }
